import {
    PROFILE_FETCH_SUCCESS,
    SET_AI_CHIPS,
    SET_AI_FILTER,
    SET_CAMPAIGN_EDIT_LOADER,
    SET_CAMPAIGN_ID,
    SET_CAMPAIGN_OBJECTIVE,
    SET_CAMPAIGN_OBJECTIVE_LOADER,
    SET_CAMPAIGN_UPDATE_LIST,
    SET_CAMPAIGN_UPDATE_LIST_LOADER,
    SET_FILTER_STEPS,
    SET_GOALS_LIST,
    SET_GOALS_LIST_LOADER,
    SET_OBJECTIVE_FILTER,
    SET_PEOPLE_CARDS,
    SET_PEOPLE_CARDS_CAMPAIGN_DETAIL,
    SET_PEOPLE_FILTER_DATA,
    SET_PEOPLE_LEADS_LOADER,
    SET_PROFILE_COUNT,
    SET_PROFILE_DATA,
    SET_PROFILE_IDS,
    SET_PUBLIC_COMPANY,
    SET_PUBLIC_COMPANY_LOADER,
    SET_PUBLIC_PROFILE,
    SET_SINGLE_CAMPAIGN_DETAIL,
    SET_SINGLE_CAMPAIGN_DETAIL_LOADER,
} from "../actions/types";

const initialState = {
    peopleAiList: [],
    peopleAiLeadLoader: false,
    peopleAiFilterData: {},
    campaignId: null,
    singleCampaignDetail: {},
    singlPublicCompany: {},
    publicProfile: null,
    campaignUpdateList: [],
    campaignUpdateTotal: 0,
    campaignUpdateCount: 0,
    campaignUpdateListLoader: false,
    profiledata: {},
    profileData: {},
    profileCount: 0,
    profileIds: null,
    campaignDetailToSend: {},
    objectiveLoader: false,
    campaignObjective: {},
    setFiltersteps: 1,
    isObjectiveFilters: null,
    goalsList: [],
    goalsListLoader: false,
    aiChips: [],
    aiFilterResponse: {},
    campaignEditLoader: false,
    profileMap: {},
    singleCampaignDetailLoader: false,
    singlPublicCompanyLoader: false
};
export default function (state = initialState, action) {
    const { type, payload, count, total, page } = action;
    switch (type) {
        case SET_PEOPLE_CARDS:
            return {
                ...state,
                peopleAiList: payload,
                peopleAiLeadLoader: false
            };
        case SET_PEOPLE_LEADS_LOADER:
            return {
                ...state,
                peopleAiLeadLoader: payload
            };
        case SET_PEOPLE_FILTER_DATA:
            return {
                ...state,
                peopleAiFilterData: payload
            };
        case SET_PROFILE_COUNT:
            return {
                ...state,
                profileCount: payload
            };
        case SET_PROFILE_IDS:
            return {
                ...state,
                profileIds: payload
            };
        case SET_PEOPLE_CARDS_CAMPAIGN_DETAIL:
            return {
                ...state,
                campaignDetailToSend: payload
            };
        case SET_CAMPAIGN_OBJECTIVE_LOADER:
            return {
                ...state,
                objectiveLoader: payload
            };
        case SET_CAMPAIGN_OBJECTIVE:
            return {
                ...state,
                objectiveLoader: false,
                campaignObjective: payload
            };
        case SET_FILTER_STEPS:
            return {
                ...state,
                setFiltersteps: payload
            };
        case SET_OBJECTIVE_FILTER:
            return {
                ...state,
                isObjectiveFilters: payload
            };
        case SET_GOALS_LIST:
            return {
                ...state,
                goalsList: payload,
                goalsListLoader: false
            };
        case SET_GOALS_LIST_LOADER:
            return {
                ...state,
                goalsListLoader: payload
            };
        case SET_AI_CHIPS:
            return {
                ...state,
                aiChips: payload
            };
        case SET_AI_FILTER:
            return {
                ...state,
                aiFilterResponse: payload
            };
        case SET_CAMPAIGN_EDIT_LOADER:
            return {
                ...state,
                campaignEditLoader: payload
            };
        case PROFILE_FETCH_SUCCESS:
            return {
                ...state,
                profileMap: {
                    ...state.profileMap,
                    [action.payload.id]: action.payload.data,
                },
            };
        case SET_CAMPAIGN_ID:
            return {
                ...state,
                campaignId: payload
            }
        case SET_SINGLE_CAMPAIGN_DETAIL:
            return {
                ...state,
                singleCampaignDetail: payload,
                singleCampaignDetailLoader: false
            }

        case SET_SINGLE_CAMPAIGN_DETAIL_LOADER:
            return {
                ...state,
                singleCampaignDetailLoader: payload
            }
        case SET_PUBLIC_COMPANY:
            return {
                ...state,
                singlPublicCompany: payload,
                singlPublicCompanyLoader: false
            }
        case SET_PUBLIC_COMPANY_LOADER:
            return {
                ...state,
                singlPublicCompanyLoader: payload
            }
        case SET_PUBLIC_PROFILE:
            return {
                ...state,
                publicProfile: payload
            }

        case SET_CAMPAIGN_UPDATE_LIST:
            return {
                ...state,
                campaignUpdateList: page === 1
                    ? payload
                    : [...state.campaignUpdateList, ...payload],
                campaignUpdateListLoader: false,
                campaignUpdateCount: count,
                campaignUpdateTotal: total
            }

        case SET_CAMPAIGN_UPDATE_LIST_LOADER:
            return {
                ...state,
                campaignUpdateListLoader: payload
            }
        case SET_PROFILE_DATA:
            return {
                ...state,
                profiledata: payload,
                profileData: payload
            }
        default:
            return state;
    }
}
